import { WSMutationConfig } from "@ws-react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import {
  QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
  QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL,
  QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE
} from "../../payeeEngagements/keys";
import { resetPayeeRequirement } from "../../../services/payeeRequirements/resetPayeeRequirement";
import { useXWingspanPayerId } from "../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";

type ResetPayeeRequirementParams = {
  payeeId: string;
  requirementId: string;
};

export const useMutationResetPayeeRequirement = (
  config?: WSMutationConfig<IRequirementResponse, WSServiceError>
) => {
  const xWingspanPayerId = useXWingspanPayerId();

  return useWSMutation(
    (request: ResetPayeeRequirementParams) => {
      return resetPayeeRequirement(
        request.payeeId,
        request.requirementId,
        xWingspanPayerId
      );
    },
    {
      ...config,
      dependencies: [
        QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
        QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE,
        QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL
      ]
    }
  );
};
